import React from 'react';
import { colors } from '@theme/colors';

type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'info' | 'primary';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: 'sm' | 'md' | 'lg';
  style?: React.CSSProperties;
}

const variantStyles: Record<BadgeVariant, { bg: string; color: string }> = {
  default: { bg: colors.neutral.gray100, color: colors.neutral.gray700 },
  success: { bg: colors.semantic.successLight, color: '#166534' },
  warning: { bg: colors.semantic.warningLight, color: '#92400e' },
  error: { bg: colors.semantic.errorLight, color: '#991b1b' },
  info: { bg: colors.semantic.infoLight, color: '#1e40af' },
  primary: { bg: '#FEE5D6', color: colors.brand.laranjaManta },
};

const sizeStyles: Record<'sm' | 'md' | 'lg', { padding: string; fontSize: string }> = {
  sm: { padding: '2px 6px', fontSize: '0.7rem' },
  md: { padding: '4px 10px', fontSize: '0.8rem' },
  lg: { padding: '6px 14px', fontSize: '0.9rem' },
};

export function Badge({ children, variant = 'default', size = 'md', style }: BadgeProps) {
  const { bg, color } = variantStyles[variant];
  const { padding, fontSize } = sizeStyles[size];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding,
        borderRadius: 20,
        fontSize,
        fontWeight: 500,
        background: bg,
        color,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {children}
    </span>
  );
}

export default Badge;
